module.exports = __webpack_public_path__ + "img/tool.72b58e90.svg";